import {AfterViewInit, Component, OnInit} from '@angular/core';
import {environment} from '../../environments/environment';
import {ActivatedRoute} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ServicesService} from '../services.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {
    adminUrl: string = environment.adminUrl;
    photoUrl: string = environment.photoUrl;
    userData;
    contatUsButton= false;

    header = 'l-header l-header_overlay';
    navbar = 'l-navbar l-navbar_t-light-trans l-navbar_expand js-navbar-sticky';
    header_menu = 'header_menu';

    contatUs: FormGroup;

    imagesCategoryWise = [];


    constructor(private route: ActivatedRoute, private _service: ServicesService) {

        // this.route.queryParams.subscribe(params => {
        //     this.param1 = params['n'];
        //     console.log(this.param1);
        // });
        this.userData = JSON.parse(localStorage.getItem('userData'));
        // console.log(this.userData);
        this.createForm();
        this.getimagesCategoryWise();
    }

    ngOnInit() {

    }

    ngAfterViewInit() {
        $('.tb-preloader-wave').fadeOut();
        $('#tb-preloader').delay(200).fadeOut('slow').remove();
        (<any>$('.js-primary-navigation')).menuzord();

    }

    public getimagesCategoryWise() {
        // this._service.getimagesCategoryWise().subscribe((data: any) => {
           // console.log('getimagesCategoryWise Called', data);
            /* this.imagesCategoryWise = [
                {cat: 'cat1', url: 'assets/img/portfolio/12.jpg'},
                {cat: 'cat1', url: 'assets/img/portfolio/18.jpg'},
                {cat: 'cat1', url: 'assets/img/portfolio/19.jpg'},
                {cat: 'cat1', url: 'assets/img/portfolio/11.jpg'},
                {cat: 'cat1', url: 'assets/img/portfolio/13.jpg'},
                {cat: 'cat1', url: 'assets/img/portfolio/14.jpg'},
                {cat: 'cat1', url: 'assets/img/portfolio/15.jpg'},
                {cat: 'cat1', url: 'assets/img/portfolio/16.jpg'},
                {cat: 'cat1', url: 'assets/img/portfolio/110.jpg'},
                {cat: 'cat1', url: 'assets/img/portfolio/17.JPG'},
                {cat: 'cat2', url: 'assets/img/portfolio/21.jpg'},
                {cat: 'cat2', url: 'assets/img/portfolio/25.jpg'},
                {cat: 'cat2', url: 'assets/img/portfolio/22.jpg'},
                {cat: 'cat2', url: 'assets/img/portfolio/24.jpg'},
                {cat: 'cat2', url: 'assets/img/portfolio/26.jpg'},
                {cat: 'cat3', url: 'assets/img/portfolio/31.jpg'},
                {cat: 'cat3', url: 'assets/img/portfolio/32.jpg'},
                {cat: 'cat3', url: 'assets/img/portfolio/33.jpg'},
                {cat: 'cat3', url: 'assets/img/portfolio/34.jpg'},
                {cat: 'cat3', url: 'assets/img/portfolio/35.jpg'},
                {cat: 'cat3', url: 'assets/img/portfolio/36.jpg'},
                {cat: 'cat3', url: 'assets/img/portfolio/37.jpg'},
                {cat: 'cat3', url: 'assets/img/portfolio/38.jpg'},
                {cat: 'cat3', url: 'assets/img/portfolio/39.jpg'},
                {cat: 'cat3', url: 'assets/img/portfolio/310.JPG'},
                {cat: 'cat3', url: 'assets/img/portfolio/311.JPG'},
                {cat: 'cat3', url: 'assets/img/portfolio/312.JPG'},
                {cat: 'cat3', url: 'assets/img/portfolio/313.JPG'},
                {cat: 'cat3', url: 'assets/img/portfolio/314.JPG'},
                {cat: 'cat4', url: 'assets/img/portfolio/41.jpg'},
                {cat: 'cat4', url: 'assets/img/portfolio/42.jpg'},
                {cat: 'cat4', url: 'assets/img/portfolio/43.jpg'},
                {cat: 'cat4', url: 'assets/img/portfolio/44.JPG'},
                {cat: 'cat4', url: 'assets/img/portfolio/45.JPG'},
                {cat: 'cat5', url: 'assets/img/portfolio/51.jpg'},
                {cat: 'cat5', url: 'assets/img/portfolio/52.jpg'},
                {cat: 'cat5', url: 'assets/img/portfolio/53.jpg'},
                {cat: 'cat5', url: 'assets/img/portfolio/54.jpg'},
                ]; */

                this.imagesCategoryWise = [
                    {cat: 'cat1', url: this.photoUrl+'/portfolio/12.jpg'},
                    {cat: 'cat1', url: this.photoUrl+'/portfolio/18.jpg'},
                    {cat: 'cat1', url: this.photoUrl+'/portfolio/19.jpg'},
                    {cat: 'cat1', url: this.photoUrl+'/portfolio/11.jpg'},
                    {cat: 'cat1', url: this.photoUrl+'/portfolio/13.jpg'},
                    {cat: 'cat1', url: this.photoUrl+'/portfolio/14.jpg'},
                    {cat: 'cat1', url: this.photoUrl+'/portfolio/15.jpg'},
                    {cat: 'cat1', url: this.photoUrl+'/portfolio/16.jpg'},
                    {cat: 'cat1', url: this.photoUrl+'/portfolio/110.jpg'},
                    {cat: 'cat1', url: this.photoUrl+'/portfolio/17.JPG'},
                    {cat: 'cat2', url: this.photoUrl+'/portfolio/21.jpg'},
                    {cat: 'cat2', url: this.photoUrl+'/portfolio/25.jpg'},
                    {cat: 'cat2', url: this.photoUrl+'/portfolio/22.jpg'},
                    {cat: 'cat2', url: this.photoUrl+'/portfolio/24.jpg'},
                    {cat: 'cat2', url: this.photoUrl+'/portfolio/26.jpg'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/31.jpg'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/32.jpg'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/33.jpg'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/34.jpg'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/35.jpg'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/36.jpg'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/37.jpg'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/38.jpg'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/39.jpg'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/310.JPG'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/311.JPG'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/312.JPG'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/313.JPG'},
                    {cat: 'cat3', url: this.photoUrl+'/portfolio/314.JPG'},
                    {cat: 'cat4', url: this.photoUrl+'/portfolio/41.jpg'},
                    {cat: 'cat4', url: this.photoUrl+'/portfolio/42.jpg'},
                    {cat: 'cat4', url: this.photoUrl+'/portfolio/43.jpg'},
                    {cat: 'cat4', url: this.photoUrl+'/portfolio/44.JPG'},
                    {cat: 'cat4', url: this.photoUrl+'/portfolio/45.JPG'},
                    {cat: 'cat5', url: this.photoUrl+'/portfolio/51.jpg'},
                    {cat: 'cat5', url: this.photoUrl+'/portfolio/52.jpg'},
                    {cat: 'cat5', url: this.photoUrl+'/portfolio/53.jpg'},
                    {cat: 'cat5', url: this.photoUrl+'/portfolio/54.jpg'},
                    ];
       // });

    }

    private createForm() {
        this.contatUs = new FormGroup({
            name:  new FormControl('', [Validators.required]),
            email:  new FormControl('', [Validators.required, Validators.email]),
            phone:  new FormControl('', [Validators.required, Validators.pattern('^[0-9]{10,10}$')]),
            message:  new FormControl('', [Validators.required, Validators.maxLength(400)]),
        });
    }

    public contatUsPhotographer() {
        this._service.contatUsPhotographer(this.contatUs.value).subscribe((data: any) => {
            if(data.status ==200){
                this.contatUsButton = true;
                // console.log(data);
                setTimeout(() => {
                    this.contatUsButton = false;
                    this.contatUs.reset();
                },2000 );
            }
       });

    }



}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/home/home.component.ts